import { ESTRATEGIA_RETRY_PADRAO, FalhaHttp, type ClienteHttp, type RespostaHttp } from '@next/infraestrutura/http'
import { CAMPOS_PROJECAO_MOTIVO_PADRAO, type OpcaoMotivoPadrao } from '../catalogo-motivo-padrao.tipos'

const ENDPOINT = '/reason'
const ehRegistro = (valor: unknown): valor is Record<string, unknown> => typeof valor === 'object' && valor !== null && !Array.isArray(valor)
const textoUtilizavel = (valor: unknown): valor is string => typeof valor === 'string' && Boolean(valor.trim())
const conservarCampos = (registro: Record<string, unknown>, campos: readonly string[]): Record<string, unknown> => Object.fromEntries(campos.filter(c => c in registro).map(c => [c, registro[c]]))
const projetar = (registro: Record<string, unknown>): OpcaoMotivoPadrao => {
  const motivo = conservarCampos(registro, CAMPOS_PROJECAO_MOTIVO_PADRAO)
  if (Array.isArray(motivo.campos_dinamicos_esperados)) {
    motivo.campos_dinamicos_esperados = motivo.campos_dinamicos_esperados.map((campo: unknown) => {
      if (!ehRegistro(campo)) return campo
      const resultado = conservarCampos(campo, ['id', 'nome', 'tipo', 'obrigatorio', 'opcoes'])
      if (Array.isArray(resultado.opcoes)) resultado.opcoes = resultado.opcoes.map((opcao: unknown) => ehRegistro(opcao) ? conservarCampos(opcao, ['valor']) : opcao)
      return resultado
    })
  }
  return motivo as OpcaoMotivoPadrao
}
const extrair = (resposta: RespostaHttp<unknown>): readonly OpcaoMotivoPadrao[] => {
  if (resposta.status === 204 || (ehRegistro(resposta.data) && 'no-data' in resposta.data)) return []
  if (!ehRegistro(resposta.data) || !Array.isArray(resposta.data.success)) {
    throw new FalhaHttp({ tipo: 'resposta_invalida', servico: 'condominio', metodo: 'GET', endpoint: ENDPOINT,
      status: resposta.status, causa: resposta.data, ...(resposta.requestId ? { requestId: resposta.requestId } : {}) })
  }
  return resposta.data.success.filter(ehRegistro).map(projetar)
}
export class ListarOpcoesMotivoPadraoRepositorioHttp {
  constructor(private readonly http: ClienteHttp) {}
  executar = async (sinal: AbortSignal): Promise<readonly OpcaoMotivoPadrao[]> => {
    const consultar = (active: boolean) => this.http.get<unknown>(ENDPOINT, { parametros: { active }, signal: sinal, retry: ESTRATEGIA_RETRY_PADRAO })
    const [ativos, inativos] = await Promise.all([consultar(true), consultar(false)])
    const ids = new Set<string>()
    return [...extrair(ativos), ...extrair(inativos)].filter(item => {
      if (!textoUtilizavel(item.id)) return true
      if (ids.has(item.id)) return false
      ids.add(item.id)
      return true
    }).sort((a, b) => (
      (textoUtilizavel(a.description) ? a.description : '').localeCompare(textoUtilizavel(b.description) ? b.description : '', 'pt-BR')
      || (textoUtilizavel(a.id) ? a.id : '').localeCompare(textoUtilizavel(b.id) ? b.id : '')
    ))
  }
}
